const haaloData = [
    {
        "id": 1,
        "options": [
            {
                "statement": "They believe great ideas can come from anywhere",
                "associatedLetter": "A"
            },
            {
                "statement": "They believe most great ideas come from those in charge",
                "associatedLetter": "H"
            }
        ]
    },
    {
        "id": 2,
        "options": [
            {
                "statement": "They thrive on regular interaction with others",
                "associatedLetter": "C"
            },
            {
                "statement": "They thrive in an independent creative environment",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 3,
        "options": [
            {
                "statement": "They are determined to win and persistent in doing so",
                "associatedLetter": "M"
            },
            {
                "statement": "They are determined to impact the world and not afraid to challenge the status quo",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 4,
        "options": [
            {
                "statement": "They love to compete and never shy away from a healthy debate",
                "associatedLetter": "M"
            },
            {
                "statement": "They love supporting others even if that means they don't get the credit",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 5,
        "options": [
            {
                "statement": "They seek to be of service, power doesn't drive them",
                "associatedLetter": "H"
            },
            {
                "statement": "They seek to be on a solid team of equals, status doesn't drive them",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 6,
        "options": [
            {
                "statement": "They always color inside the lines",
                "associatedLetter": "H"
            },
            {
                "statement": "They march to the beat of their own drum",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 7,
        "options": [
            {
                "statement": "They are quick to do exactly what is needed when called upon",
                "associatedLetter": "H"
            },
            {
                "statement": "They are quick to speak up and challenge current thinking",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 8,
        "options": [
            {
                "statement": "They typically seek out perspectives other than their own",
                "associatedLetter": "H"
            },
            {
                "statement": "They typically rely heavily on their own perspective ",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 9,
        "options": [
            {
                "statement": "They are great at delivering under clear direction and guidance",
                "associatedLetter": "H"
            },
            {
                "statement": "They are great at executing their part of a plan",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 10,
        "options": [
            {
                "statement": "They believe winning is the only thing that matters",
                "associatedLetter": "M"
            },
            {
                "statement": "They believe the cause is the only thing that matters",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 11,
        "options": [
            {
                "statement": "They believe a chain of command leads to better teamwork",
                "associatedLetter": "H"
            },
            {
                "statement": "They believe trust is the key to better teamwork",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 12,
        "options": [
            {
                "statement": "They like to know how they can best support other teammates ",
                "associatedLetter": "C"
            },
            {
                "statement": "They like to know how success is defined by the organization",
                "associatedLetter": "H"
            }
        ]
    },
    {
        "id": 13,
        "options": [
            {
                "statement": "They build relationships with people who share their vision ",
                "associatedLetter": "A"
            },
            {
                "statement": "They build relationships with people that can help advance their career",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 14,
        "options": [
            {
                "statement": "They are high energy and others look to them for answers",
                "associatedLetter": "A"
            },
            {
                "statement": "They are a good listener and others count on their support",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 15,
        "options": [
            {
                "statement": "They believe manipulation isn't bad if the cause is just",
                "associatedLetter": "A"
            },
            {
                "statement": "They believe manipulation isn't bad if that's what it takes to win",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 16,
        "options": [
            {
                "statement": "They work best when we are measured as a group",
                "associatedLetter": "C"
            },
            {
                "statement": "They work best when we are focused on our vision",
                "associatedLetter": "A"
            }
        ]
    },
    {
        "id": 17,
        "options": [
            {
                "statement": "They are most successful when they have others around who are supportive",
                "associatedLetter": "C"
            },
            {
                "statement": "They are most successful on a winning team no matter what role they play",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 18,
        "options": [
            {
                "statement": "They often make friends with coworkers",
                "associatedLetter": "C"
            },
            {
                "statement": "They tend to view coworkers as competition",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 19,
        "options": [
            {
                "statement": "They like to understand the goal but then be left alone to execute",
                "associatedLetter": "M"
            },
            {
                "statement": "They like to understand the goal but then work with the team to execute",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 20,
        "options": [
            {
                "statement": "They win based on creativity and innovation",
                "associatedLetter": "A"
            },
            {
                "statement": "They win based on hustle and grit",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 21,
        "options": [
            {
                "statement": "They prefer to be surrounded by people with the same objective",
                "associatedLetter": "H"
            },
            {
                "statement": "They prefer to be surrounded by people who care about each other",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 22,
        "options": [
            {
                "statement": "They thrive in areas where they know the next step but can always handle a curveball",
                "associatedLetter": "H"
            },
            {
                "statement": "They thrive in a winning environment where everyone competes with each other",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 23,
        "options": [
            {
                "statement": "They love working within a team of people where we are recognized as a whole",
                "associatedLetter": "H"
            },
            {
                "statement": "They love to stand out as the result of their talents and contribution",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 24,
        "options": [
            {
                "statement": "They believe advancement comes from following the rules",
                "associatedLetter": "H"
            },
            {
                "statement": "They believe advancement comes from being the best performer",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 25,
        "options": [
            {
                "statement": "They enjoy working on a creative team with the ability to bring in new ideas ",
                "associatedLetter": "A"
            },
            {
                "statement": "They enjoy working on a team with a clear objective from leadership",
                "associatedLetter": "H"
            }
        ]
    },
    {
        "id": 26,
        "options": [
            {
                "statement": "They will stop at nothing to create the future they see",
                "associatedLetter": "A"
            },
            {
                "statement": "They will stop at nothing to support the team",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 27,
        "options": [
            {
                "statement": "They struggle to connect with people who don't believe in what they do",
                "associatedLetter": "A"
            },
            {
                "statement": "They feel connected to others who believe in what they believe",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 28,
        "options": [
            {
                "statement": "They take tremendous pride in the accuracy of their work",
                "associatedLetter": "H"
            },
            {
                "statement": "They take tremendous pride in adding value to a high-performing team",
                "associatedLetter": "C"
            }
        ]
    },
    {
        "id": 29,
        "options": [
            {
                "statement": "They believe in collective accountability",
                "associatedLetter": "C"
            },
            {
                "statement": "They believe in personal accountability ",
                "associatedLetter": "M"
            }
        ]
    },
    {
        "id": 30,
        "options": [
            {
                "statement": "They connect success to their ability to help the leader succeed",
                "associatedLetter": "H"
            },
            {
                "statement": "They connect success to how quickly they are able to grow in their career",
                "associatedLetter": "M"
            }
        ]
    }
];

export default haaloData;